import { ReactComponent as CreditIcon } from "../../../assets/icons/credit_card.svg";

const StatsCard = ({ label, value }) => {
    return (
        <div className="bg-[#F9FBFC] flex flex-col items-start gap-2 rounded-[9px] border border-[#E6EAEF] bg-white p-3 w-full text-left">
            <span className="text-[14px] text-[#32353C]">{label}</span>

            <div className="flex justify-start items-center gap-2">
                <div className="flex h-[40px] w-[40px] items-center justify-center rounded-lg bg-[#F9FAFB]">
                    <CreditIcon />
                </div>
                <span className="text-[32px] font-semibold text-[#101828]">
                    {value}
                </span>
            </div>
        </div>
    );
};

const StatsOverview = ({enterpriseStats}) => {
    return (
        <div className="w-full bg-white rounded-xl border border-[#EAECF0] p-4 mb-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                <StatsCard
                    label="Credit Report Remaining this month"
                    value={enterpriseStats?.credit_remaining ?? 0}
                />
                <StatsCard
                    label="Reports Ordered this month"
                    value={enterpriseStats?.order_create_count ?? 0}
                />
                <StatsCard
                    label="Invites Send"
                    value={enterpriseStats?.invite_sent ?? 0}
                />
                <StatsCard
                    label="Invites Accepted"
                    value={enterpriseStats?.invite_accepted ?? 0}
                />
            </div>
        </div>
    );
};

export default StatsOverview;
